// src/index.ts
function revueFromSubscriptionSubmit(revueFromSubscriptionConfig) {
  var profileId = revueFromSubscriptionConfig.profileId,
    customUrl = revueFromSubscriptionConfig.customUrl,
    memberEmail = revueFromSubscriptionConfig.memberEmail,
    memberFirstName = revueFromSubscriptionConfig.memberFirstName,
    memberLastName = revueFromSubscriptionConfig.memberLastName;
  if (!profileId && !customUrl) {
    throw new Error("profileId or customUrl is required");
  } else if (!memberEmail) {
    throw new Error("memberEmail is required");
  }
  var form = document.createElement("form");
  form.action = customUrl || "https://www.getrevue.co/profile/".concat(profileId, "/add_subscriber");
  form.method = "post";
  form.id = "revue-form";
  form.name = "revue-form";
  form.target = "_blank";
  form.style.display = "none";
  var emailInput = document.createElement("input");
  emailInput.type = "email";
  emailInput.name = "member[email]";
  emailInput.value = memberEmail;
  form.appendChild(emailInput);
  if (memberFirstName) {
    var firstNameInput = document.createElement("input");
    firstNameInput.type = "text";
    firstNameInput.name = "member[first_name]";
    firstNameInput.value = memberFirstName;
    form.appendChild(firstNameInput);
  }
  if (memberLastName) {
    var lastNameInput = document.createElement("input");
    lastNameInput.type = "text";
    lastNameInput.name = "member[last_name]";
    lastNameInput.value = memberLastName;
    form.appendChild(lastNameInput);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
var src_default = revueFromSubscriptionSubmit;
export { src_default as default, revueFromSubscriptionSubmit };